<template>
  <n-config-provider
    :locale="currentLocale.locale"
    :date-locale="currentLocale.dateLocale"
  >
    <n-message-provider>
      <n-notification-provider placement="top">
        <n-dialog-provider>
          <router-view />
        </n-dialog-provider>
      </n-notification-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue"; // ref, computed, watch 임포트
import {
  NConfigProvider,
  NMessageProvider,
  NNotificationProvider,
  NDialogProvider,
  koKR, // 한국어 로케일
  dateKoKR, // 한국어 날짜 로케일
  enUS, // 영어 로케일 (예시)
  dateEnUS, // 영어 날짜 로케일 (예시)
  // 필요한 다른 언어 로케일들도 임포트
} from "naive-ui";

const currentLanguage = ref(localStorage.getItem("userLanguage") || "ko"); // 기본값 'ko'

const naiveUiLocales = {
  ko: { locale: koKR, dateLocale: dateKoKR },
  en: { locale: enUS, dateLocale: dateEnUS },
};

const currentLocale = computed(() => {
  return (
    naiveUiLocales[currentLanguage.value as keyof typeof naiveUiLocales] ||
    naiveUiLocales.ko
  ); // 지원하지 않는 언어일 경우 기본값(한국어)
});

watch(currentLanguage, (newLang) => {
  localStorage.setItem("userLanguage", newLang);
});

function changeLanguage(lang: string) {
  currentLanguage.value = lang;
}
</script>

<style>
* {
  margin: 0px;
  padding: 0px;
}
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

nav {
  padding: 30px;
}

nav a.router-link-exact-active {
  color: #42b983;
} */

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 6px solid #ccc;
  border-top-color: #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.n-message-container {
  z-index: 9999 !important;
}

.n-notification-container {
  z-index: 9999 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
